export const isAuthenticated = state => {
  return !!state.session.user && !!state.session.accessToken;
};

// roles
export const isAdmin = state => {
  return state.session.user && state.session.user.roles
    ? state.session.user.roles.includes("admin")
    : false;
};

export const isSupporter = state => {
  // Check if the user and achievements are defined
  if (state.session.user && state.session.user.achievements) {
    // List of achievements to check against
    const validAchievements = ["Mercenary", "Lord", "Hero", "Champion"];

    // Check if any of the user's achievements match the valid achievements list
    return state.session.user.achievements.some(achievement =>
      validAchievements.includes(achievement.name)
    );
  }

  // Return false if no user or achievements are defined
  return false;
};

export const sessionExpired = state => {
  let now = new Date();
  let expiresAt = new Date(state.session.expiresAt * 1000);
  return !!(now > expiresAt);
};

export const bearerToken = state => {
  return `Bearer ${state.session.accessToken}`;
};
